import React from "react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import { FormHelperText } from "@material-ui/core";

export default function RadioButtonsGroup({
  name,
  label,
  value,
  handleChange,
  heading,
  error,
  helperText,
}) {
  return (
    <FormControl component="fieldset" error={error}>
      <FormLabel component="legend">{heading}</FormLabel>
      <RadioGroup
        color="primary"
        row
        aria-label="cbs-forms"
        name={name}
        value={value}
        onChange={handleChange}
      >
        {label.map((item, i) => (
          <FormControlLabel
            key={i}
            value={item}
            control={<Radio color="primary" style={{color: "#0166A4"}} />}
            label={item}
          />
        ))}
      </RadioGroup>
      <FormHelperText  style={{ marginTop:"-10px" }}>
        <span style={{ color: "#f44336"}}>{helperText}</span>
      </FormHelperText>
    </FormControl>
  );
}
